import { useContext, useEffect } from 'react';

import last from 'lodash/last';
import startCase from 'lodash/startCase';
import { useLocation } from 'react-router-dom';

import BreadCrumbsContext from '@src/components/breadcrumbs/BreadCrumbContext';

const pathToTitle = (path) => {
    if (!path) return path;

    path = path
        .replace(/-|_/g, ' ')
        .replace(' & ', ' and ');
    path = startCase(path);

    path = path
        .replace('Guides And Rate Bulletins', 'Underwriting Guidelines and Rate Bulletins')
        .replace('Auto Agent 360', 'Auto | Agent360')
        .replace('Home Agent 360', 'Home | Agent360')
        .replace('Umbrella Agent 360', 'Umbrella | Agent360')
        .replace('Auto Ars', 'Auto | ARS')
        .replace('Home Ars', 'Home | ARS')
        .replace('Combo Ars', 'Combo | ARS')
        .replace('Grandprotect Ars', 'GrandProtect | ARS')
        .replace('Pelp Ars', 'PELP | ARS')
        .replace('Faq', 'FAQ')
        .replace('Pelp', 'PELP')
        .replace('Pcms', 'PCMS')
        .replace('And', 'and')
        .replace('Or', 'or')
        .replace('But', 'but')
        .replace('In', 'in')
        .replace('On', 'on')
        .replace('For', 'for')
        .replace('To', 'to')
        .replace('Pcms', 'PCMS')
        .replace('Ars', 'ARS')
        .replace('Elearnings', 'eLearning')
        .replace('Farmers General Insurance Agency', 'Farmers General Insurance Agency, Inc.')
        .replace('Ready To Use', 'Ready-To-Use')
        .replace('Co Branded', 'Co-Branded')
        .replace('Grandprotect', 'GrandProtect')
        .replace('insurance', 'Insurance')
        .replace('Co Op Marketing Center', 'Co-op Marketing Center')
        .replace('Sitemap', 'Site Map');

    return path;
};

const itemsFromPathname = (pathname) => {
    const items = pathname.split('/').reduce((acc, path) => {
        if (!path) return acc;

        const prevItem = last(acc);
        const prevUrl = prevItem ? prevItem.url : '';
        const url = `${prevUrl}/${path}`;

        const title = pathToTitle(path);

        return [...acc, { url, title }];
    }, []);

    items.unshift({ url: '/', title: 'Home' });

    return items;
};

const useBreadCrumbsFromPath = () => {
    const { pathname } = useLocation();
    const { setItems } = useContext(BreadCrumbsContext);

    useEffect(() => {
        setItems(itemsFromPathname(pathname));

        return () => {
            setItems([]);
        };
    }, [pathname, setItems]);
};

const useAddBreadCrumbItem = (url, title) => {
    const { addItem, removeItem } = useContext(BreadCrumbsContext);

    useEffect(() => {
        addItem(url, title);
        return () => {
            removeItem(url);
        };
    }, [url, title, addItem, removeItem]);
};

const useAddSearchBreadCrumbTitle = (title) => {
    const { addItem, removeItem } = useContext(BreadCrumbsContext);
    const { pathname, search } = useLocation();

    useEffect(() => {
        if (!title || !search) return;

        const url = `${pathname}${search}`;
        addItem(url, title);
        return () => {
            removeItem(url);
        };
    }, [pathname, search, title, addItem, removeItem]);
};

const useSetCurrentBreadCrumbTitle = (title) => {
    const { addItem, removeItem } = useContext(BreadCrumbsContext);
    const { pathname } = useLocation();

    useEffect(() => {
        if (!title) return;

        addItem(pathname, title);
        return () => {
            removeItem(pathname);
        };
    }, [pathname, title, addItem, removeItem]);
};

const useBreadCrumbItems = () => {
    const { items } = useContext(BreadCrumbsContext);

    return items;
};

export {
    useAddBreadCrumbItem,
    useAddSearchBreadCrumbTitle,
    useBreadCrumbItems,
    useBreadCrumbsFromPath,
    useSetCurrentBreadCrumbTitle,
};
